import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicTable, EmptyState, BaasicButton, TableFilter, QueryDropdown, DateQueryPicker } from "core/components";
import { isSome } from "core/utils";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";

const WoundOrderListTemplate = function({ woundOrderListViewStore }) {
    
    const { 
        tableStore, 
        routes,
        queryUtility, 
        authorization,
        facilityStore, 
        woundPatientStore,
        woundOrderStatusStore,
        dateOfServicePickerStore } = woundOrderListViewStore;

    return (
        <ApplicationListLayout
            store={woundOrderListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                <BaasicButton className="btn btn--base btn--primary"  label={'LIST_LAYOUT.CREATE_BUTTON'} onClick={() => routes.create()} authorized={authorization ? authorization.create : true}></BaasicButton>
            </PageNavigation>
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility}>
                            <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                                <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                                <QueryDropdown queryUtility={queryUtility} store={woundPatientStore} propertyName="patientId" label="Patient" />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                                <QueryDropdown queryUtility={queryUtility} store={woundOrderStatusStore} propertyName="woundOrderStatusId" label="Order Status" />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <label className="form__group__label">Date Of Service</label>
                            <DateQueryPicker store={dateOfServicePickerStore} queryUtility={queryUtility} propertyName="dateOfService" />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="FACILITY_ORDER.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

WoundOrderListTemplate.propTypes = {
    woundOrderListViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const {
        onEdit,
        onPreview,
        orderingCalendar,
        onDelete
    } = actions;
    if (
        !isSome(onEdit) && !isSome(onPreview) && !isSome(orderingCalendar) && !isSome(onDelete)
    )
        return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--edit u-icon--sml"
                        label="FACILITY_ORDER.LIST.BUTTON.EDIT"
                        onlyIcon={true}
                        onClick={() => onEdit(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--preview u-icon--sml"
                        label="FACILITY_ORDER.LIST.BUTTON.PREVIEW"
                        onlyIcon={true}
                        onClick={() => onPreview(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(orderingCalendar) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--schedules--grey u-icon--sml"
                        label="FACILITY_ORDER.LIST.BUTTON.ORDERING_CALENDAR"
                        onlyIcon={true}
                        onClick={() => orderingCalendar(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.delete : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--delete u-icon--sml"
                        label="FACILITY_ORDER.LIST.BUTTON.DELETE"
                        onlyIcon={true}
                        onClick={() => onDelete(item)}
                    ></BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(WoundOrderListTemplate);